<template lang="pug">
.page-main(:style="grid" :class="{ 'visible-grid': areas.length > 1 }")
    Area(
        v-for="area in areas"
        :key="area.key"
        :config="area"
        :hide="hide"
        :dragging="dragging"
        :sections-address="[area.key, 'sections']"
        :area-section-options="sectionOptions"
        :area-grid-options="gridOptions"
        @dragging="value => dragging = value"
    )
</template>

<script>

// import Vue from 'vue'

import _ from 'lodash'

import Area from '@/components/Page/Area'
import { useSetupStore } from '@/stores'

export default {
    name: 'Main',
    props: {
        // module: {
        //     type: String,
        //     required: true
        // },
        // page: {
        //     type: Object,
        //     required: true
        // },
        config: {
            type: Object,
            required: true
        },
        sectionOptions: {
            type: Array,
            required: true
        },
        hide: {
            type: [Array, Boolean],
            default: false
        },
        // i: {
        //     type: Number
        // }
    },
    data() {
        return {
            dragging: false,
        }
    },
    components: {
        Area,
    },
    computed: {
        // config() {
        //     const view = _.get(this.page, 'view')
        //     const config = _.get(this.activeCms, 'config.template.pages', [])
        //         .find(item => item.view === view)
        //
        //     return config
        // },
        grid() {
            let style = []

            style.push({ 'display': 'grid' })
            style.push({ 'grid-gap': '.5rem' })

            const grid = _.get(this.config, 'grid')
            if (grid && grid.columns && grid.rows) {
                style.push({ 'grid-template-columns': grid.columns })
                style.push({ 'grid-template-rows': grid.rows })
            } else {
                style.push({ 'grid-template-columns': '1fr' })
                style.push({ 'grid-template-rows': '1fr' })
            }

            return style
        },
        areas() {
            let areas = _.get(this.config, 'grid.areas') || []

            if (! areas.length) areas.push({
                key: 'main',
                row: '1 / 1',
                column: '1 / 1',
                grids: [],
                sections: this.sectionOptions,
            })

            return areas
        },
        // sectionOptions() {
        //     const sections = _.get(this.config, 'sections') || []
        //
        //     let options = []
        //     sections.forEach(section => {
        //         const config = _.get(this.activeCms, 'config.template.sections', [])
        //             .find(item => item.key === section.key)
        //
        //         const option = {...section, ...config}
        //         // TODO: initialize section
        //         options.push(option)
        //     })
        //
        //     return options
        // },
        gridOptions() {
            const grids = _.get(this.config, 'grids') || []

            let options = []
            grids.forEach(grid => {
                const config = _.get(this.activeCms, 'config.template.grids', [])
                    .find(item => item.key === grid.key)

                const option = {...grid, ...config}
                // TODO: initialize grid
                options.push(option)
            })

            return options
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
}
</script>

<style lang="sass" scoped>
.page-main
    &.visible-grid
        .page-area
            min-height: 58px
            // background: #F0F0F0
            // border-radius: 4px
            // padding: 15px 10px
            // padding-left: 10px
            // padding-top: 40px
            // padding-top: 0
</style>
